export default "__VITE_ASSET__B9YBIifM__"